/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { AiringOffer } from 'client-code/airing';
import { OfferPreview } from 'client-code/previews';
import { AnyAction } from 'redux';
import {
    SET_ACTIONS_STRIP_HIGHLIGHT_INDEX,
    SET_ACTIONS_STRIP_ACTION_ITEMS_COUNT,
    SET_IS_ACTIONS_STRIP_ACTIVE,
    SET_IS_STANDARD_INFO_ACTIVE,
    SET_IS_FULL_INFO_ACTIVE,
    SET_IS_TRICKPLAY_MENU_ACTIVE,
    SET_ACTION_BUTTON_ACTIVE_POSITIONS_AVAILABLE,
    SET_ACTION_BUTTON_CURRENT_ACTIVE_INDEX,
    SET_ACTIONS_STRIP_AVAILABLE_ACTION_ITEM,
    UPDATE_STANDARD_INFO_TIMER,
    UPDATE_FULL_INFO_TIMER,
    UPDATE_TRICKPLAY_TIMER,
    SET_PREVIEW_DATA,
    SET_AIRING_DATA,
    UPDATE_ACTION_STRIP_REFERECE,
    SET_ENTERTING_CHANNEL_NUMBER_ENABLED,
    SET_ENTERED_CHANNEL_NUMBER,
    UPDATE_ENTERING_CHANNEL_NUMBER_ENABLED_TIMER,
    UPDATE_TRICKPLAY_BAR_LONG_KEY_PRESS_INTERVAL_ID,
    SET_ACTIONS_STRIP_HIGHLIGHT_BORDER_ACTIVE,
    SET_MEDIA_BUTTON_MOUSE_OVER_INDEX,
    SET_AIRING_DATA_STATUS,
    INFO_BANNER_SET_BANNER_TIP_VISIBLITY,
} from './infobanner.types';
import { MediaButtonState, MediaButtonTypes } from './mediabuttontypes';
import { AiringDataStates } from '../../../core/enums/AiringDataStates';

export const infoBannerSetBannerTipVisibilityAction = (isBannerTipVisible: boolean): AnyAction => ({
    type: INFO_BANNER_SET_BANNER_TIP_VISIBLITY,
    payload: {
        isBannerTipVisible,
    },
});

export const setActionsStripHighlightIndexAction = (
    actionsStripHighlightIndex: number,
): AnyAction => ({
    type: SET_ACTIONS_STRIP_HIGHLIGHT_INDEX,
    payload: {
        actionsStripHighlightIndex,
    },
});

export const setActionsStripHighlightBorderActiveAction = (
    actionsStripHighlightBorderActive: boolean,
): AnyAction => ({
    type: SET_ACTIONS_STRIP_HIGHLIGHT_BORDER_ACTIVE,
    payload: {
        actionsStripHighlightBorderActive,
    },
});

export const setAvailableActionItemsAction = (availableActionItems: Array<any>): AnyAction => ({
    type: SET_ACTIONS_STRIP_AVAILABLE_ACTION_ITEM,
    payload: {
        availableActionItems,
    },
});

export const setActionItemsCountAction = (actionItemsCount: number): AnyAction => ({
    type: SET_ACTIONS_STRIP_ACTION_ITEMS_COUNT,
    payload: {
        actionItemsCount,
    },
});

export const setIsActionsStripActive = (isActionsStripActive: boolean): AnyAction => ({
    type: SET_IS_ACTIONS_STRIP_ACTIVE,
    payload: { isActionsStripActive },
});

export const setIsStandardInfoActive = (isStandardInfoActive: boolean): AnyAction => ({
    type: SET_IS_STANDARD_INFO_ACTIVE,
    payload: { isStandardInfoActive },
});

export const setIsFullInfoActive = (isFullInfoActive: boolean): AnyAction => ({
    type: SET_IS_FULL_INFO_ACTIVE,
    payload: { isFullInfoActive },
});

export const setIsTrickplayMenuActive = (isTrickplayMenuActive: boolean): AnyAction => ({
    type: SET_IS_TRICKPLAY_MENU_ACTIVE,
    payload: { isTrickplayMenuActive },
});

export const setActivePositionsAction = (
    activePositionsAvailable: Map<MediaButtonTypes, MediaButtonState>,
): AnyAction => ({
    type: SET_ACTION_BUTTON_ACTIVE_POSITIONS_AVAILABLE,
    payload: {
        activePositionsAvailable,
    },
});

export const setCurrentActiveIndexAction = (currentActiveIndex: number): AnyAction => ({
    type: SET_ACTION_BUTTON_CURRENT_ACTIVE_INDEX,
    payload: {
        currentActiveIndex,
    },
});

export const updateStandardInfoTimeoutIdAction = (standardInfoTimeoutId: any): AnyAction => ({
    type: UPDATE_STANDARD_INFO_TIMER,
    payload: {
        standardInfoTimeoutId,
    },
});

export const updateFullInfoTimeoutIdAction = (fullInfoTimeoutId: any): AnyAction => ({
    type: UPDATE_FULL_INFO_TIMER,
    payload: {
        fullInfoTimeoutId,
    },
});

export const updateTrickPlayBarTimeoutIdAction = (trickPlayBarTimeoutId: any): AnyAction => ({
    type: UPDATE_TRICKPLAY_TIMER,
    payload: {
        trickPlayBarTimeoutId,
    },
});

export const updateActionStripReferenceAction = (
    actionStripReference: React.RefObject<HTMLDivElement> | null,
): AnyAction => ({
    type: UPDATE_ACTION_STRIP_REFERECE,
    payload: {
        actionStripReference,
    },
});

export const setEnteringChannelNumberEnabledAction = (
    enteringChannelNumberEnabled: boolean,
): AnyAction => ({
    type: SET_ENTERTING_CHANNEL_NUMBER_ENABLED,
    payload: {
        enteringChannelNumberEnabled,
    },
});

export const setEnteredChannelNumberAction = (channelNumberEntered: string): AnyAction => ({
    type: SET_ENTERED_CHANNEL_NUMBER,
    payload: {
        channelNumberEntered,
    },
});

export const updateEnteringChannelNumberTimeoutIdAction = (
    enteringChannelNumberTimeoutId: any,
): AnyAction => ({
    type: UPDATE_ENTERING_CHANNEL_NUMBER_ENABLED_TIMER,
    payload: {
        enteringChannelNumberTimeoutId,
    },
});

export const updateTrickPlayBarLongKeyPressIntervalIdAction = (
    trickPlayBarLongKeyPressIntervalId: any,
): AnyAction => ({
    type: UPDATE_TRICKPLAY_BAR_LONG_KEY_PRESS_INTERVAL_ID,
    payload: {
        trickPlayBarLongKeyPressIntervalId,
    },
});

export const setMediaButtonMouseOverIndex = (mediaButtonMouseOverIndex: number): AnyAction => ({
    type: SET_MEDIA_BUTTON_MOUSE_OVER_INDEX,
    payload: {
        mediaButtonMouseOverIndex,
    },
});
